import React from 'react';

const LoadingScreen: React.FC = () => {
  return (
    <div style={{
      height: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
    }}>
      <div style={{ textAlign: 'center', color: 'white' }}>
        <i className="pi pi-spin pi-spinner" style={{ fontSize: '48px', marginBottom: '16px' }}></i>
        <p style={{ fontSize: '18px', margin: 0 }}>Loading...</p>
      </div>
    </div>
  );
};

export default LoadingScreen;